import { TUNINGS } from '@theory/tunings';
import { useAppStore } from '@app/store/useAppStore';
import shared from './dropdownShared.module.css';

export function TuningDropdown() {
  const tuningId = useAppStore((s) => s.selectedTuningId);
  const setTuning = useAppStore((s) => s.setTuning);

  return (
    <select
      className={shared.select}
      value={tuningId}
      onChange={(e) => setTuning(e.target.value)}
      aria-label="Tuning"
    >
      {TUNINGS.map((t) => (
        <option key={t.id} value={t.id}>
          {t.name}
        </option>
      ))}
    </select>
  );
}
